import PricingPlansSection from '../../../sections/AdminDashboard/PricingPlans/PricingPlans';

const PricingPlans = () => <PricingPlansSection />;

export default PricingPlans;
